import { Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { globalStyles } from '../../styles';
import { styles } from './styles';

interface KeyTopicsProps {
  event: PublicEventDetailsResponse;
}

function truncateString(str: string) {
  return str.length > 255 ? str.slice(0, 255) + '...' : str;
}

const KeyTopics = ({ event }: KeyTopicsProps) => {
  const { t } = useTranslation();

  const eventKeyTopicsItems = useMemo(() => {
    return event?.website_content?.keytopics
      ?.filter(e => e.published)
      .sort((a, b) => a.order - b.order)
      ?.map(keyTopic => ({
        title: keyTopic.title,
        subtitle: keyTopic.description,
        order: keyTopic.order,
      }));
  }, [event?.website_content?.keytopics]);

  return (
    <View style={globalStyles.body}>
      <Text
        style={{
          ...globalStyles.mediumTitle,
          color: event?.design?.themeColor,
        }}
      >
        {event?.name}
      </Text>
      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor,
          marginTop: 0,
          marginBottom: 0,
        }}
      />

      <Text style={{ ...styles.smallText, paddingHorizontal: 53 }}>
        {event?.about}
      </Text>

      <Text
        style={{
          ...globalStyles.mediumTitle,
          color: event?.design?.themeColor ?? 'black',
        }}
      >
        {t('key-topics-at-a-glance')}
      </Text>
      <View
        style={{
          ...globalStyles.lineBar,
          borderColor: event?.design?.themeColor,
          marginTop: 0,
          marginBottom: 0,
        }}
      />

      <View style={styles.gridWrapper}>
        {eventKeyTopicsItems.map((item: any) => (
          <View wrap={false} style={styles.gridItem} key={item.order}>
            <Text
              style={{
                ...styles.itemTitle,
                color: event?.design?.themeColor ?? 'black',
              }}
            >
              {item.title}
            </Text>
            <Text style={{ ...styles.smallText, textAlign: 'center' }}>
              {truncateString(item.subtitle)}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default KeyTopics;
